import { useEffect } from 'react';

import { getStep } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/config/stepConstants';

const collectHelpImages = (help) => [
  ...(help?.images ?? []),
  ...(help?.image ? [help.image] : []),
  ...(help?.groupedImages ?? []).flatMap((group) => [
    ...group.innerpack,
    group.unit,
  ]),
];

// Fetch and decode the next step's example images ahead of time, so the
// step-change animation is not competing with large image loads.
export const usePreloadNextStepImages = (nextStepKey) => {
  useEffect(() => {
    const sources = collectHelpImages(getStep(nextStepKey)?.help);

    sources.forEach((src) => {
      const image = new Image();
      image.src = src;
      image.decode().catch(() => {});
    });
  }, [nextStepKey]);
};
